import styled from "styled-components";

export const WrapperInner = styled.div`
.filters{
.ant-select-selector, .ant-input-number-outlined {
    background: var(--app-surface) !important;
    color: var(--app-text) !important;
    border-color: var(--app-border) !important;
    min-height: 42px;
}
.ant-input-number .ant-input-number-input{
    padding: 9px 11px;
}
.ant-select-selection-item{
    font-size: 13px !important;
    font-weight: 500;
}
.ant-select-item{
font-size: .95rem !important;
    font-weight: 500;
}
    .ant-select .ant-select-arrow{
        height: 22px;
    }
.ant-select .ant-select-selection-placeholder{
font-size: 13px !important;
    color: var(--app-text-muted) !important;
    font-weight: 500;
}
.ant-picker-input input{font-size:13px}
.ant-picker-range {
    border:1px solid var(--app-border);
}
.ant-select-item-option-content{
 font-size: .9rem !important;
}

.ant-select-multiple .ant-select-selection-item-content{
    font-size: 12px;
}

.ant-select-selection-item,
.ant-select-arrow {
    color: var(--app-text) !important;
}

.ant-select-dropdown {
    background: var(--app-surface) !important;
    border: 1px solid var(--app-border);
}

.ant-select-dropdown .ant-select-item {
    color: var(--app-text);
}

.ant-select-dropdown .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background: var(--app-surface-alt) !important;
}

.ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background: rgba(244, 91, 104, 0.14) !important;
    color: var(--app-text) !important;
}
}

.add-alert{
.ant-select-selector, .ant-input-number-outlined {
    background: var(--app-surface-alt) !important;
    color: var(--app-text) !important;
    border-color: var(--app-border) !important;
    min-height: 42px;
}
.ant-input-number .ant-input-number-input{
    padding: 9px 11px;
}
.ant-select-selection-item{
    font-size: 13px !important;
    font-weight: 500;
    color: var(--app-text) !important;
}
.ant-select-item{
font-size: .95rem !important;
    font-weight: 500;
}
    .ant-select .ant-select-arrow{
        height: 22px;
        color: var(--app-text-muted);
    }
.ant-select .ant-select-selection-placeholder{
font-size: 13px !important;
    color: var(--app-text-muted) !important;
    font-weight: 500;
}
.ant-picker-input input{font-size:13px}
.ant-picker-range {
    border:1px solid var(--app-border);
}

.ant-select-multiple .ant-select-selection-item-content{
    font-size: 12px;
}

.ant-select-dropdown .ant-select-item{
    font-size: 12px;
}
}
    .alert-read-row {
        background-color: var(--app-surface-alt) !important;
        opacity: 0.6;
    }

    .ant-table-row.alert-read-row {
        background-color: var(--app-surface-alt) !important;
        opacity: 0.6;
    }

    .text-two {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /* white-space: pre-wrap; */
    width: 250px;
    margin-bottom: 0 !important;
  }
`;